import { useNavigate } from "react-router-dom";
import * as compSettings from "./settings";

const Chips = ({ id, extendedSettings }) => {
  const navigate = useNavigate();

  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  // Settings'ten değerleri al
  const marginX = settings.marginX.value + "px";
  const marginY = settings.marginY.value + "px";
  const gap = settings.gap.value + "px";
  const chipPaddingX = settings.chipPaddingX.value + "px";
  const chipPaddingY = settings.chipPaddingY.value + "px";
  const fontSize = settings.fontSize.value + "px";
  const borderRadius =
    settings.borderRadius.value === 9999
      ? "9999px"
      : settings.borderRadius.value + "px";
  const backgroundColor = settings.backgroundColor.value;
  const textColor = settings.textColor.value;
  const borderColor = settings.borderColor.value;
  const borderWidth = settings.borderWidth.value + "px";
  const textAlignment = settings.textAlignment.value;
  const showScrollbar = settings.showScrollbar.value;
  const items = JSON.parse(settings.items.value)
  console.log(items)

  const onItemClick = (item) => {
    //TODO:handle other item types
    navigate(`/category`, {
        state: {
          id:item.id,
          name:item.label
        },
    })
  };

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: showScrollbar ? "auto" : "none",
        msOverflowStyle: showScrollbar ? "auto" : "none",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: gap,
          whiteSpace: "nowrap",
          paddingTop: marginY,
          paddingBottom: marginY,
          paddingLeft: marginX,
          paddingRight: marginX,
          scrollbarWidth: showScrollbar ? "auto" : "none",
          msOverflowStyle: showScrollbar ? "auto" : "none",
        }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              paddingLeft: chipPaddingX,
              paddingRight: chipPaddingX,
              paddingTop: chipPaddingY,
              paddingBottom: chipPaddingY,
              fontSize: fontSize,
              backgroundColor: backgroundColor,
              color: textColor,
              border: `${borderWidth} solid ${borderColor}`,
              borderRadius: borderRadius,
              cursor: "pointer",
              textAlign: textAlignment,
              display: "inline-block",
            }}
            onClick={() => onItemClick(item)}
          >
            {item.label}
          </div>
        ))}
      </div>
      {!showScrollbar && (
        <style>{`
          .category-chips-scroll::-webkit-scrollbar { display: none; }
        `}</style>
      )}
    </div>
  );
};

export default Chips;
